/**
 * @overview toLower
 * @author Amir Absalyamov <mr.amirka@ya.ru>
 */

module.exports = (v) => v.toLowerCase();
